import { mobiClient } from '@/services/axiosConfig'
import { GetEsimDevicesRes } from './types'

export const getEsimDevices = async (): Promise<GetEsimDevicesRes | undefined> => {
  try {
    const res = await mobiClient.get('/devices')
    return res.data
  } catch (e) {
    console.error('Sim recovery: tan create failed', e)
  }
}
